module.exports = __webpack_public_path__ + "sh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sh.svg
// module id = 799
// module chunks = 0